import { OnChanges, SimpleChanges } from '@angular/core';
// video.component.ts
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import videojs from 'video.js';

//import { VideoStatusService } from 'src/app/services/activity/video-status.service';

@Component({
  selector: 'app-video',
  template: `
    <video #target class="video-js" controls playsinline preload="auto"></video>
  `,
  styleUrls: [
    './video.component.scss'
  ],
  encapsulation: ViewEncapsulation.None,
})
export class VideoComponent implements OnInit, OnDestroy, OnChanges {
  @ViewChild('target') target!: ElementRef;

  @Input() options!: {
    fluid: boolean,
    aspectRatio: string,
    autoplay: boolean,
    controls: boolean,
    sources: {
      src: string,
      type?: string,
    }[],
  };

  player!: videojs.Player;

  constructor(
    private elementRef: ElementRef,
    //private videoStatusService: VideoStatusService
  ) { }
  ngOnInit() {
    // instantiate Video.js
    setTimeout(() => {
      //this.videoStatusService.setVideoCompleted(false);
      console.debug('[VIDEO OPTIONS] ', this.options)
      this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() { });

      /*let lastAllowedTime = 0;

      this.player.on('timeupdate', () => {
        const currentTime = this.player.currentTime();

        if (currentTime - lastAllowedTime > 2) {
          this.player.currentTime(lastAllowedTime);
        } else {
          lastAllowedTime = currentTime;
        }
      })

      this.player.on('ended', () => {
        this.videoStatusService.setVideoCompleted(true);
      });*/
    }, 500);
  }
  ngOnChanges(_changes: SimpleChanges): void {

    setTimeout(() => {
      if (this.options) {
        // const { src, type } = this.options.sources[0]
        // this.player.src({ src, type })
        // this.player.load()
      }
      // this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
      //   console.log('onPlayerReady', this);
      // });
    }, 500);
  }

  ngOnDestroy() {
    // destroy player
    if (this.player) {
      this.player.dispose();
    }
  }
}
